import { Component  } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { AmazingTimePickerService } from "amazing-time-picker";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { TipoCambioService } from '../../services/configuracion/tipo-cambio.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';


import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { LoginService } from 'app/services/login/login.service';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-nuevo-tipo-cambio',
  templateUrl: './nuevo-tipo-cambio.component.html',
  styleUrls: ['./nuevo-tipo-cambio.component.css'],
  providers: [
    DatePipe,DecimalPipe,
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class NuevoTipoCambioComponent   {

  private config = {hour:7 , minute :15 , meriden:'PM' , format : 12}
  form: FormGroup;

  constructor(private atp: AmazingTimePickerService, 
    private tipoCambioService:TipoCambioService,
     private datepipe:DatePipe, private router:Router,
     private decimalPipe: DecimalPipe,
     private loginService:LoginService) { 

      let fecha = new Date();
      let user = sessionStorage.getItem('UserActive');
      let Usuario = JSON.parse(user);
      
    this.form = new FormGroup({
      Fecha: new FormControl({ value:fecha, disabled: true }  , [Validators.required  ]),
      Hora: new FormControl(this.datepipe.transform(Date(),'HH:mm'), [Validators.required ]),
      Fuente: new FormControl("", [Validators.required ]),
      Compra: new FormControl("", [Validators.required ]),
      Venta: new FormControl("", [Validators.required ]),
      Vigente_Indicador: new FormControl("S", [Validators.required ]),
      Alta_Usuario: new FormControl(Usuario.Usuario, [Validators.required ])
    })
  }
  


 

  guardarCambios(){
    
    if (this.form.invalid){

      Swal.fire({
        title: "Algo salio mal!",
        text: "Error al registrar Tipo de Cambio",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return;
    }


    Swal.fire({
      title: 'Espere',
      text:'Guardado Información',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
    });
    Swal.showLoading();
  
    this.form.controls["Compra"].setValue(this.cortarComa( this.form.controls["Compra"].value));
    this.form.controls["Venta"].setValue(this.cortarComa( this.form.controls["Venta"].value));


    this.form.controls["Fecha"].setValue(
      this.datepipe.transform(
        this.form.controls["Fecha"].value,
        "yyyy-MM-dd"
      )
    );


    this.tipoCambioService.crearTipoDeCambio(this.form.getRawValue())
        .subscribe(resp => {

          Swal.fire({
            title: "Felicidades",
            text: "Tipo de Cambio Registrado Correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res =>{
          
            if (res.value == true ){
              this.loginService.clickGuard = true;
              this.router.navigate(['/contabilidad/tipoCambio/listado']);
            }

          });
        },err => {
          Swal.fire({
            title: "Algo salio mal!",
            text: "Error al registrar Tipo de Cambio",
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          })

          
        })
  }

  tranformarDecimal(control: any, decimal?: number) {
    let valor;
   
      valor =  this.decimalPipe.transform(this.cortarComa(this.form.controls[`${control}`].value), `1.4` );
      this.form.controls[`${control}`].setValue(valor);
   
  }

  cortarComa(numero: any): any {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }


}
